module.exports = __webpack_public_path__ + "static/media/download_filled.154153b0.svg";